module.exports = __webpack_public_path__ + "static/media/icon-linkedin.141585aa.svg";